import { render, staticRenderFns } from "./backgroundcarrerpage.vue?vue&type=template&id=d929b116&scoped=true&"
import script from "./backgroundcarrerpage.vue?vue&type=script&lang=js&"
export * from "./backgroundcarrerpage.vue?vue&type=script&lang=js&"
import style0 from "./backgroundcarrerpage.vue?vue&type=style&index=0&id=d929b116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d929b116",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VImg,VParallax})
